import React, { Component } from 'react';
import authUtils from '../../../auth/utils';
import { withRouter } from 'react-router-dom';
import { submenus } from '../../routes';
import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar'
import { matchPath } from 'react-router';

class Nav extends Component {

	constructor(props) {
		super(props);


		let currentMenu = -1, expandedIndex = -1, currentSubmenu = -1;

		const { location: { pathname }, routes } = this.props;
		const allRoutes = routes.filter(x => !!x.path).concat(Object.values(submenus).flat());
		const routeMatch = allRoutes.find(x => matchPath(pathname, x));
		if (routeMatch) {
			const currentPath = routeMatch.mainMenuPath || routeMatch.path;

			const menuItems = routes.filter(route => this.hasPermission(route));

			// try to find a matching top level menu item	
			currentMenu = menuItems.findIndex(x => x.path === currentPath);
			if (currentMenu === -1) {
				// try to find a matching submenu item
				menuItems.some((menuItem, parentIndex) => {
					let submenu = submenus[menuItem.menuName];
					const hasSubmenu = !!submenu;
					if (hasSubmenu) {
						submenu = submenu.filter(x => this.hasPermission(x));
						currentSubmenu = submenu.findIndex(x => x.path === currentPath);
						if (currentSubmenu > -1) {
							currentMenu = parentIndex;
							expandedIndex = parentIndex;
							return true;	// break
						}
						return false;
					}
				});
			}
		}


		this.state = { expandedIndex, currentMenu, currentSubmenu };
	}

	componentDidMount() {
	}

	handleMenuItemClick(route, index) {
		if (submenus[route.menuName]) {
			const expandedIndex = this.determineExpandedMenuIndex(route, index);
			this.setState({ expandedIndex });
		} else if (this.state.currentMenu != index) {
			this.setState({ currentMenu: index, expandedIndex: -1, currentSubmenu: -1 });
			this.navigate(route);
			if (this.props.onMenuItemClick) {
				this.props.onMenuItemClick();
			}
		}
	}

	determineExpandedMenuIndex(route, index) {
		const { expandedIndex } = this.state;
		let newExpandedIndex = -1;
		if (submenus[route.menuName] && index != expandedIndex) {
			newExpandedIndex = index;
		}
		return newExpandedIndex;
	}

	handleSubmenuItemClick(route, submenuIndex, parentIndex) {
		const { currentMenu, currentSubmenu } = this.state;
		if (currentMenu != parentIndex || currentSubmenu != submenuIndex) {
			this.setState({ currentMenu: parentIndex, currentSubmenu: submenuIndex, expandedIndex: parentIndex });
			this.navigate(route);
			if (this.props.onMenuItemClick) {
				this.props.onMenuItemClick();
			}
		}
	}

	navigate(route) {
		const path = route.mainMenuPath || route.path;
		if (path) {
			const { history } = this.props;
			history.push(path);
		}
	}

	hasPermission(route) {
		const { currentUser, franchisor } = this.props;
		return route.showInMainMenu(franchisor, currentUser) && (!route.businessFunctionName || authUtils.hasPermission(currentUser, route.businessFunctionName));
	}

	renderSubmenuItem(route, index, menuIndex, t) {
		const { currentMenu, currentSubmenu } = this.state;
		return (
			<li key={index} className={menuIndex === currentMenu && index === currentSubmenu ? 'active' : ''}>
				<a href='javascript:void(0);' onClick={() => this.handleSubmenuItemClick(route, index, menuIndex)}>
					{route.offset && <span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>}<span className='title'>{t(route.textResourceKey)}</span>
				</a>
			</li>
		);
	}

	renderSubmenu(submenu, menuIndex, t) {
		if (!submenu) {
			return null;
		}

		const { currentMenu, expandedIndex } = this.state;
		const submenuStyle = expandedIndex == menuIndex && expandedIndex > -1 ? { display: 'block' } : { display: 'none' };
		return (
			<ul className='sub-menu' style={submenuStyle}>
				{submenu.map((route, index) => (
					this.renderSubmenuItem(route, index, menuIndex, t)
				))}
			</ul>
		);
	}

	menuItemClasses(index, hasSubmenu) {
		const { currentMenu, currentSubmenu, expandedIndex } = this.state;
		const open = index === expandedIndex;
		const active = currentMenu === index && (!hasSubmenu || currentSubmenu > -1);

		return `${open ? 'open': ''} ${active ? 'active': ''}`;
	}

	renderMenuItem(route, index, t) {
		let submenu = submenus[route.menuName];
		const hasSubmenu = !!submenu;
		if (hasSubmenu) {
			submenu = submenu.filter(x => this.hasPermission(x));
			if (submenu.length === 0) {
				return null;
			}
		}
		const classes = this.menuItemClasses(index, hasSubmenu);
		return (
			<li key={index} className={classes}>
				<a href='javascript:void(0);' onClick={() => this.handleMenuItemClick(route, index)}>
					<i className={route.icon}></i>
					<span className='title'>{t(route.textResourceKey)}</span>
					{hasSubmenu && <i className='icon-arrow'></i>}
					<span className='selected' />
				</a>
				{hasSubmenu && this.renderSubmenu(submenu, index, t)}
			</li>
		);
	}

	renderMenu() {
		const { routes, t } = this.props;
		return (
			<ul className='main-navigation-menu'>
				{routes.filter(route => this.hasPermission(route))
					.map((route, index) => this.renderMenuItem(route, index, t))}
			</ul>
		);
	}

	render() {
		const menu = this.renderMenu();
		return (
			<div className='sidebar-fixed'>
				<PerfectScrollbar suppressScrollX>
					<div className='main-navigation'>
						{menu}
					</div>
				</PerfectScrollbar>
			</div>
		);
	}
}

export default withRouter(Nav);